import React from "react";
//#region types
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import { FileViewerContainer } from "components/common";
import useInvoiceCreateContext from "../../contexts/create/useInvoiceContext";
//#endregion

const InvoiceTemplate: React.FC = (props) => {
  const invoiceCreateContext = useInvoiceCreateContext();

  const [fileMeta, setFileMeta] = React.useState<ImageMeta[]>();

  React.useEffect(() => {
    setFileMeta(
      invoiceCreateContext.invoiceHtml
        ? [
            {
              id: 0,
              contentType: "html",
              numberOfPages: 1,
              data: invoiceCreateContext.invoiceHtml,
            },
          ]
        : invoiceCreateContext.invoiceHtml === undefined
          ? undefined
          : []
    );
  }, [invoiceCreateContext.invoiceHtml]);

  // The HTML stays undefined until the first preview is generated; without loading the viewer shows the no-preview
  // placeholder. A failed preview sets it to an empty string, which ends the loading state with an empty file list:
  // the viewer only re-reads its loading state when the file list changes.
  return (
    <FileViewerContainer
      meta={fileMeta}
      parentId={0}
      preventDownload
      loading={invoiceCreateContext.invoiceHtml === undefined}
    />
  );
};

export default InvoiceTemplate;
